import React from 'react';

export default function SalesIcon() {
	return (
		<svg width="100%" height="100%" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1077_14810" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="41">
				<rect y="0.819702" width="40" height="40" fill="#2D3846" />
			</mask>
			<g mask="url(#mask0_1077_14810)">
				<path d="M5 35.8197V32.4864L8.33333 29.153V35.8197H5ZM11.6667 35.8197V25.8197L15 22.4864V35.8197H11.6667ZM18.3333 35.8197V22.4864L21.6667 25.8614V35.8197H18.3333ZM25 35.8197V25.8614L28.3333 22.528V35.8197H25ZM31.6667 35.8197V19.153L35 15.8197V35.8197H31.6667ZM5 27.1947V22.4864L16.6667 10.8197L23.3333 17.4864L35 5.8197V10.528L23.3333 22.1947L16.6667 15.528L5 27.1947Z" fill="#2D3846" />
			</g>
		</svg>
	);
}
